<template>
  <div class="container" :style="{ 'background-image': 'url(' + bgUrl + ')' }">
    <Header />
    <div class="home">
      <router-view />
    </div>
    <a-back-top />
    <Footer />
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import Header from "../components/Header";
import Footer from "../components/Footer";
export default {
  name: "HomeLayout",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      bgUrl: "/assets/background.svg",
    };
  },
  created() {
    const tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if (tenantConfig.homeBackground) {
      this.bgUrl = tenantConfig.themeConfig.homeBackground;
    }
  },
};
</script>

<style lang="less" scoped>
.container {
  // min-height: 100vh;
  background: #f2f6f8;
  .home {
    max-width: 1200px;
    margin: auto;
    // min-height: calc(100vh - 154px);
  }
  /deep/.ant-list-pagination{
    text-align: center;
  }
}
</style>